import { Divider, List, Typography, Box } from "@mui/material";
import DealListItem from "models/deals/DealListItem";

const DealList = ({ dealList: { title, deals }, onClick }) => {
  return (
    <List>
      <Typography variant="h6" sx={{ mt: 2 }}>
        {title}
      </Typography>
      {deals.map((deal, index) => {
        return (
          <Box
            sx={{ border: "0.5px solid", marginBottom: "5px" }}
            key={`${deal.id}-${index}`}
          >
            <DealListItem
              key={`${deal.id}-${index}`}
              object={deal}
              onClick={onClick}
            />
          </Box>
        );
      })}
    </List>
  );
};

const CommitteeList = ({ committeeDealsList, onClick }) => {
  const sections = [
    ["New deals", committeeDealsList.new_deals],
    ["Current deals", committeeDealsList.current_deals],
    ["Investments", committeeDealsList.investment_deals],
  ];

  return (
    <Box>
      {sections.map(([title, dealLists], index) => (
        <div key={`list2-${index}`}>
          <Typography variant="h5" sx={{ mt: 3 }}>
            {title}
          </Typography>
          <Divider />
          {dealLists.map((dealList, index) => {
            return (
              <DealList
                dealList={dealList}
                onClick={onClick}
                key={`list-${index}`}
              />
            );
          })}
        </div>
      ))}
    </Box>
  );
};

export default CommitteeList;
